<template>
  <div id="about" class="area">
    <h2 data-en="About">論壇簡介</h2>
    <div class="wrapper">
      <div class="area-box">
        <div class="content">
          <div>
            <p>《今周刊》長期觀察國際趨勢，深入發掘綠色產業與再生能源的重要性。</p>
            <p>本次論壇，將以「能源轉型2.0」為題，探討臺灣能源的下一步，包含：未來能源基礎建設、能源國產化推動，人才技術與接軌國際等議題，藉以展示企業能量和媒合專業人才，希冀能引領臺灣於推動再生能源的路上邁步跨足。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style>
#about {
  background: #E8F6F5;
}

</style>
